  // src/api/salesOrderApi.js
  import axiosInstance from "./axiosInstance";

  // ✅ Fetch orders by state, status, date range
  export const fetchorders = async (state, status, startDate, endDate) => {
    try {
      const payload = {
        state: state || "",
        status: status || "",
        start_date: startDate || "",
        end_date: endDate || "",
      };
      const res = await axiosInstance.post("/order/get_orders_by_state", payload);
      const raw = res.data?.data;
      return Array.isArray(raw) ? raw : [];
    } catch (error) {
      console.error("Error fetching orders:", error);
      return [];
    }
  };

  export const upsertOrders = async (data) => {
    try {
      const res = await axiosInstance.post("/order/update_order_status", data);
      return res.data;
    } catch (error) {
      console.error("Error in upsertOrders:", error.response || error);
      throw error;
    }
  };

  // ✅ Fetch all active products with GST & rate details
export const fetchActiveProducts = async () => {
  try {
    const res = await axiosInstance.get("/order/products/active");
    if (res.data?.success && Array.isArray(res.data.data)) {
      return res.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching active products:", error);
    return [];
  }
};

export const fetchOrderDetailsByStatus = async (orderId, newStatus) => {
  try {
    const res = await axiosInstance.get(
      `/order/${orderId}?newStatus=${newStatus}`
    );

    const raw =
      res.data?.data?.[0]?.get_sales_order_details?.[0];

    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Error fetching order timeline details:", error);
    return null;
  }
};

export const updateDispatchedQty = async (orderId, items) => {
  try {
    const res = await axiosInstance.post(
      "/order/update_dispatched_qty",
      {
        order_id: orderId,
        items: items, // can be null
      }
    );

    return res.data;
  } catch (error) {
    console.error("Error updating dispatched qty:", error.response || error);
    throw error;
  }
};
